(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/* All scripts that only need to run on product pages */

jQuery(document).ready(function ($) {
  // Prevents WC gallery images from opening in both Fancybox and WC inbuilt Lightbox
  $('.woocommerce-product-gallery__image a').addClass('nofancybox');

  // Prevents product gallery image cutoff when resizing
  $(window).on('resize blur', function () {
    var activeImage = $('.woocommerce-product-gallery__image.flex-active-slide');
    var activeHeight = $(activeImage).outerHeight();
    var newStyle = "overflow:hidden; position:relative; height:".concat(activeHeight, "px;"); // Remove set height value, use active image height instead
    $('.woocommerce-product-gallery--with-images .flex-viewport').attr('style', newStyle);
  });
});

},{}]},{},[1]);
